import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { AuditTrialDetails } from '../../../../../shared/models/audits/audit-trial-details';
import { PanelList } from '../../../../../shared/models/panel-list';
import { CommonService } from '../../../../../shared/services/common.service';
import { FilterMenu } from '../../../../../shared/models/filter-menu';
import { SortMenu } from '../../../../..//shared/models/sort-menu';

@Component({
  selector: 'app-change-control-audit-summary',
  templateUrl: './change-control-audit-summary.component.html',
  styleUrls: ['./change-control-audit-summary.component.scss']
})
export class ChangeControlAuditSummaryComponent implements OnInit {
  @Input() auditSummaryDetails!: AuditTrialDetails[];
  @Output() attributeDetailsOfTransaction = new EventEmitter();
  isChangeControlAuditSummaryLoaded: boolean = false;
  changeControlAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight:true
  };

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.bindChangeControlAuditSummary();
  }

  bindChangeControlAuditSummary = () => {
    this.changeControlAuditSummaryInput.lists = this.auditSummaryDetails;
    this.changeControlAuditSummaryInput.filters = this.getFiltersForActionItemAuditList();
    this.changeControlAuditSummaryInput.sort = this.getSortFieldsForActionItemAuditList();
    this.changeControlAuditSummaryInput.clearSelection = true;
    this.isChangeControlAuditSummaryLoaded = !this.commonService.IsListEmpty(this.auditSummaryDetails);
    this.changeControlAuditSummaryInput = { ...this.changeControlAuditSummaryInput };
  }
  private getFiltersForActionItemAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };
  private getSortFieldsForActionItemAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      }
    );
    return sortMenu;
  };
  showAuditAttributeDetails = (data: any) => {
    this.attributeDetailsOfTransaction.emit(data);;
  }

}
